import pushClevertapEvent from '../pushClevertapEvent';

export function advancedTransferEnabled(email: string) {
  pushClevertapEvent('Adv Transfer Enabled', {
    Time: new Date().toISOString(),
    Email: email,
  });
}

export function advancedPOEnabled(email: string) {
  pushClevertapEvent('Adv PO Enabled', {
    Time: new Date().toISOString(),
    Email: email,
  });
}
